"use client";

import { Turnstile } from "@marsidev/react-turnstile";
import { env } from "@/env";

interface TurnstileWidgetProps {
  onSuccess: (token: string) => void;
  onError?: () => void;
  onExpire?: () => void;
  action?: string;
  size?: "normal" | "compact" | "flexible";
}

export function TurnstileWidget({ onSuccess, onError, onExpire, action, size = "normal" }: TurnstileWidgetProps) {
  return (
    <div className="flex justify-center w-full">
      <Turnstile
        siteKey={env.NEXT_PUBLIC_TURNSTILE_SITE_KEY}
        onSuccess={onSuccess}
        onError={onError}
        onExpire={onExpire}
        options={{
          theme: "light",
          size,
          action,
        }}
      />
    </div>
  );
}
